<template>
    <el-menu
    background-color="#e5e6e6" 
    text-color="#99c5d3" 
    active-text-color="#251706"
    router>
        <el-menu-item key="ActivityList" index="/ActivityList">
            Activity列表
        </el-menu-item>
        <el-menu-item key="PythonList" index="/PythonList">
            Python列表
        </el-menu-item>
    </el-menu>
    <!-- <el-main>
        <el-menu-item key="ActivityList" index="/ActivityList">
            Activity列表
        </el-menu-item>
    </el-main> -->


</template>

<script>
    export default{
        data(){
            return {
                collapsed:false
            }
        }
    }
</script>

<style scoped>
    /* .logo{
        height: 32px;  
        margin: 16px;
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 17px;
    } */
    /* .el-menu{
        height:calc(100vh - 70px);
    } */

    .el-menu{
        height:calc(100vh - 70px);
    }
</style>